import {locale} from 'localeApp';

import usStates from './us.json';
import plStates from './pl.json';

const countryStates = locale === 'pl' ? plStates : usStates;
export default countryStates;
